/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-clone': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" d="M6.5 0a.5.5 0 0 1 .5.5V2h2.5a.5.5 0 0 1 .492.41L10 2.5v7a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5V8H.5a.5.5 0 0 1-.492-.41L0 7.5v-7A.5.5 0 0 1 .5 0zM9 3l-2.489-.001-.01.002H4v5.998h5V3zM6 1H1v6h2V2.5a.5.5 0 0 1 .5-.5H6V1z" _fill="#376F99" fill-rule="evenodd"/>'
  }
})
